import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
import { SUBJECT_LIST_QUERY } from './getList';
const REARRANGE_SUBJECTS_MUTATION = gql `
  mutation EP_RearrangeSubjects(
    $examLevelID: ID!
    $type: Int!
    $subjectIDs: [ID!]!
  ) {
    ep_rearrangeSubjects(
      examLevelID: $examLevelID
      type: $type
      subjectIDs: $subjectIDs
    )
  }
`;
export function useRearrangeSubjectsMutation(options) {
    return useGQLMutation(REARRANGE_SUBJECTS_MUTATION, {
        ...options,
        update(cache, { data }, { variables }) {
            if (!data?.ep_rearrangeSubjects || !variables) {
                return;
            }
            cache.updateQuery({
                query: SUBJECT_LIST_QUERY,
                variables: {
                    examLevelID: variables.examLevelID,
                    type: variables.type,
                    pagination: {
                        offset: 0,
                        limit: 50,
                    },
                },
            }, ({ ep_subjectList: existingData }) => {
                const byID = new Map(existingData.list.map((subject) => [subject.id, subject]));
                const reordered = variables.subjectIDs
                    .map(id => byID.get(id))
                    .filter(Boolean);
                return {
                    ep_subjectList: {
                        ...existingData,
                        list: reordered,
                    },
                };
            });
        },
    });
}
